module.exports = __webpack_public_path__ + "static/media/photoInactive.5a07f736.svg";